'use strict';

var angular = require('angular');
var SelectCarrierController = function SelectCarrierController($scope, restangular, $cookies, $rootScope, $stateParams, $log) {
  function getCarriers() {
    angular.element.ajax({
      url: '/api/configuration/carriers'
    }).done(function (data) {
      $scope.carriers = data.results;
    });
  }
  $scope.carrier = '';
  getCarriers();
  $scope["continue"] = function () {
    $cookies.put('carrierCode', $scope.carrier);
    sessionStorage.setItem('carrierCode', $scope.carrier);
    $log.info('$stateParams', JSON.stringify($stateParams));
    if ($stateParams.nextState.url) {
      window.location.replace($stateParams.nextState.url);
    } else {
      $log.info('Missing url in ' + JSON.stringify($stateParams.nextState));
      window.location.replace('');
    }
  };
  $scope.noSelectedCarrier = function () {
    return $scope.carrier === '';
  };
};
SelectCarrierController.$inject = ['$scope', 'Restangular', '$cookies', '$rootScope', '$stateParams', '$log'];
module.exports = SelectCarrierController;